// src/pages/LoginPage.jsx
import React, { useState, useEffect } from 'react';
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  sendPasswordResetEmail
} from 'firebase/auth';
import { auth, googleProvider } from '../firebase';
import { theme } from '../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage({ navigateTo }) {

  const user = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigateTo('shop');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Reset email sent. Please check your inbox.");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await signInWithPopup(auth, googleProvider);
      navigateTo('shop');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section style={{ padding: '6rem 24px', background: theme.bgLight, minHeight: '80vh' }}>
      <div style={{
        maxWidth: '480px',
        margin: '0 auto',
        background: 'white',
        padding: '3rem',
        borderRadius: '16px',
        boxShadow: theme.shadowMd
      }}>

        <h1 style={{
          textAlign: 'center',
          fontFamily: "'Roboto Slab', serif",
          marginBottom: '2rem'
        }}>
          {isResetMode ? "Reset Password" : "Welcome Back"}
        </h1>

        {error && (
          <p style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>
            {error}
          </p>
        )}

        {message && (
          <p style={{ color: 'green', textAlign: 'center', marginBottom: '1rem' }}>
            {message}
          </p>
        )}

        <form onSubmit={isResetMode ? handleResetPassword : handleEmailLogin}>

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '1rem',
              marginBottom: '1rem',
              borderRadius: '8px',
              border: `1px solid ${theme.border}`
            }}
          />

          {!isResetMode && (
            <>
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '1rem',
                  marginBottom: '0.5rem',
                  borderRadius: '8px',
                  border: `1px solid ${theme.border}`
                }}
              />

              <p
                onClick={() => {
                  setIsResetMode(true);
                  setError('');
                  setMessage('');
                }}
                style={{
                  textAlign: 'right',
                  fontSize: '0.9rem',
                  marginBottom: '1.5rem',
                  cursor: 'pointer',
                  color: theme.primary,
                  fontWeight: 500
                }}
              >
                Forgot Password?
              </p>
            </>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '1rem',
              background: theme.primary,
              color: 'white',
              border: 'none',
              borderRadius: '50px',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading
              ? isResetMode ? 'Sending...' : 'Signing in...'
              : isResetMode ? 'Submit Reset Request' : 'Login'}
          </button>
        </form>

        {isResetMode && (
          <p
            onClick={() => {
              setIsResetMode(false);
              setError('');
              setMessage('');
            }}
            style={{
              textAlign: 'center',
              marginTop: '1.5rem',
              cursor: 'pointer',
              color: theme.primary,
              fontWeight: 500
            }}
          >
            Back to Login
          </p>
        )}

        {!isResetMode && (
          <>
            <div style={{
              textAlign: 'center',
              margin: '1.5rem 0',
              color: theme.textLight
            }}>
              or
            </div>

            <button
              onClick={handleGoogleLogin}
              disabled={loading}
              style={{
                width: '100%',
                padding: '1rem',
                background: '#4285F4',
                color: 'white',
                border: 'none',
                borderRadius: '50px',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px'
              }}
            >
              <img
                src="https://www.google.com/favicon.ico"
                alt="Google"
                style={{ width: '20px', height: '20px' }}
              />
              Continue with Google
            </button>
          </>
        )}

        {!isResetMode && (
          <p style={{ textAlign: 'center', marginTop: '2rem' }}>
            Don't have an account?{' '}
            <span
              onClick={() => navigateTo('signup')}
              style={{ color: theme.primary, cursor: 'pointer', fontWeight: 600 }}
            >
              Sign Up
            </span>
          </p>
        )}

      </div>
    </section>
  );
}
// // src/pages/LoginPage.jsx
// import React, { useState, useEffect } from 'react';
// import {
//   signInWithEmailAndPassword,
//   signInWithPopup,
//   sendPasswordResetEmail
// } from 'firebase/auth';
// import { auth, googleProvider } from '../firebase';
// import { theme } from '../utils/constants';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// export default function LoginPage({ navigateTo }) {

//   const user = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (user) {
//       navigate('/dashboard');
//     }
//   }, [user, navigate]);

//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleEmailLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setMessage('');

//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       navigateTo('shop');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoogleLogin = async () => {
//     setLoading(true);
//     setError('');
//     setMessage('');

//     try {
//       await signInWithPopup(auth, googleProvider);
//       navigateTo('shop');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleForgotPassword = async () => {
//     if (!email) {
//       setError("Enter your email first to reset password.");
//       return;
//     }

//     try {
//       await sendPasswordResetEmail(auth, email);
//       setMessage("Password reset email sent. Check your inbox.");
//       setError('');
//     } catch (err) {
//       setError(err.message);
//       setMessage('');
//     }
//   };

//   return (
//     <section style={{ padding: '6rem 24px', background: theme.bgLight, minHeight: '80vh' }}>
//       <div style={{
//         maxWidth: '480px',
//         margin: '0 auto',
//         background: 'white',
//         padding: '3rem',
//         borderRadius: '16px',
//         boxShadow: theme.shadowMd
//       }}>

//         <h1 style={{
//           textAlign: 'center',
//           fontFamily: "'Roboto Slab', serif",
//           marginBottom: '2rem'
//         }}>
//           Welcome Back
//         </h1>

//         {error && (
//           <p style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>
//             {error}
//           </p>
//         )}

//         {message && (
//           <p style={{ color: 'green', textAlign: 'center', marginBottom: '1rem' }}>
//             {message}
//           </p>
//         )}

//         <form onSubmit={handleEmailLogin}>
//           <input
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={e => setEmail(e.target.value)}
//             required
//             style={{
//               width: '100%',
//               padding: '1rem',
//               marginBottom: '1rem',
//               borderRadius: '8px',
//               border: `1px solid ${theme.border}`
//             }}
//           />

//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={e => setPassword(e.target.value)}
//             required
//             style={{
//               width: '100%',
//               padding: '1rem',
//               marginBottom: '0.5rem',
//               borderRadius: '8px',
//               border: `1px solid ${theme.border}`
//             }}
//           />

//           {/* Forgot Password */}
//           <p
//             onClick={handleForgotPassword}
//             style={{
//               textAlign: 'right',
//               fontSize: '0.9rem',
//               marginBottom: '1.5rem',
//               cursor: 'pointer',
//               color: theme.primary,
//               fontWeight: 500
//             }}
//           >
//             Forgot Password?
//           </p>

//           <button
//             type="submit"
//             disabled={loading}
//             style={{
//               width: '100%',
//               padding: '1rem',
//               background: theme.primary,
//               color: 'white',
//               border: 'none',
//               borderRadius: '50px',
//               fontWeight: 600,
//               cursor: loading ? 'not-allowed' : 'pointer',
//               opacity: loading ? 0.7 : 1
//             }}
//           >
//             {loading ? 'Signing in...' : 'Login'}
//           </button>
//         </form>

//         <div style={{
//           textAlign: 'center',
//           margin: '1.5rem 0',
//           color: theme.textLight
//         }}>
//           or
//         </div>

//         <button
//           onClick={handleGoogleLogin}
//           disabled={loading}
//           style={{
//             width: '100%',
//             padding: '1rem',
//             background: '#4285F4',
//             color: 'white',
//             border: 'none',
//             borderRadius: '50px',
//             fontWeight: 600,
//             cursor: loading ? 'not-allowed' : 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '12px'
//           }}
//         >
//           <img
//             src="https://www.google.com/favicon.ico"
//             alt="Google"
//             style={{ width: '20px', height: '20px' }}
//           />
//           Continue with Google
//         </button>

//         <p style={{ textAlign: 'center', marginTop: '2rem' }}>
//           Don't have an account?{' '}
//           <span
//             onClick={() => navigateTo('signup')}
//             style={{ color: theme.primary, cursor: 'pointer', fontWeight: 600 }}
//           >
//             Sign Up
//           </span>
//         </p>

//       </div>
//     </section>
//   );
// }
// // src/pages/LoginPage.jsx
// import React, { useState } from 'react';
// import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
// import { auth, googleProvider } from '../firebase';
// import { theme } from '../utils/constants';
// import { useNavigate } from 'react-router-dom';

// import { useAuth } from '../context/AuthContext';

// export default function LoginPage({ navigateTo }) {

//  const user = useAuth();
//  const navigate = useNavigate();
//  if (user) {
//   navigate('/dashboard');   // or '/admin' — wherever your order management lives
// }


//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleEmailLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       navigateTo('shop'); // or home/dashboard
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoogleLogin = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       await signInWithPopup(auth, googleProvider);
//       navigateTo('shop');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section style={{ padding: '6rem 24px', background: theme.bgLight, minHeight: '80vh' }}>
//       <div style={{ maxWidth: '480px', margin: '0 auto', background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: theme.shadowMd }}>
//         <h1 style={{ textAlign: 'center', fontFamily: "'Roboto Slab', serif", marginBottom: '2rem' }}>
//           Welcome Back
//         </h1>

//         {error && <p style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>{error}</p>}

//         <form onSubmit={handleEmailLogin}>
//           <input
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={e => setEmail(e.target.value)}
//             required
//             style={{ width: '100%', padding: '1rem', marginBottom: '1rem', borderRadius: '8px', border: `1px solid ${theme.border}` }}
//           />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={e => setPassword(e.target.value)}
//             required
//             style={{ width: '100%', padding: '1rem', marginBottom: '1.5rem', borderRadius: '8px', border: `1px solid ${theme.border}` }}
//           />

//           <button
//             type="submit"
//             disabled={loading}
//             style={{
//               width: '100%',
//               padding: '1rem',
//               background: theme.primary,
//               color: 'white',
//               border: 'none',
//               borderRadius: '50px',
//               fontWeight: 600,
//               cursor: loading ? 'not-allowed' : 'pointer',
//               opacity: loading ? 0.7 : 1
//             }}
//           >
//             {loading ? 'Signing in...' : 'Login'}
//           </button>
//         </form>

//         <div style={{ textAlign: 'center', margin: '1.5rem 0', color: theme.textLight }}>or</div>

//         <button
//           onClick={handleGoogleLogin}
//           disabled={loading}
//           style={{
//             width: '100%',
//             padding: '1rem',
//             background: '#4285F4',
//             color: 'white',
//             border: 'none',
//             borderRadius: '50px',
//             fontWeight: 600,
//             cursor: loading ? 'not-allowed' : 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '12px'
//           }}
//         >
//           <img src="https://www.google.com/favicon.ico" alt="Google" style={{ width: '20px', height: '20px' }} />
//           Continue with Google
//         </button>

//         <p style={{ textAlign: 'center', marginTop: '2rem' }}>
//           Don't have an account?{' '}
//           <span
//             onClick={() => navigateTo('signup')}
//             style={{ color: theme.primary, cursor: 'pointer', fontWeight: 600 }}
//           >
//             Sign Up
//           </span>
//         </p>
//       </div>
//     </section>
//   );
// }